import React, {Fragment} from 'react';
import {GOOGLE_MAPS_KEY, SCHEMA_MAP} from "../Const";
import {LoadScript} from '@react-google-maps/api';
import MapView from "./MapView";
import FilterDesktop from "../components/FilterDesktop";
import MemberList from "../components/MemberList";
import MemberDetail from "../components/MemberDetail";
import ListView from "./ListView";
import AbstractMode from "./AbstractMode";
import {changeUrl, changeUrlForMember} from "../service/Url";

// Static libraries array to prevent re-rendering
const GOOGLE_MAPS_LIBRARIES = ['places'];

class Desktop extends AbstractMode {

    render() {

        const {
            categories,
            members,
            mapProps,
            onSelectCategory,
            onSelectPlace,
            onSliderChange,
            onSliderChangeComplete,
            filter,
            onChangeSort,
            handleGeoPosition,
            removeGeoPosition
        } = this.props;


        return (
            <Fragment>

                <LoadScript googleMapsApiKey={GOOGLE_MAPS_KEY} libraries={GOOGLE_MAPS_LIBRARIES}>
                    <div className={'viewmode-desktop schema-' + this.state.schema + ' ' + (this.state.sidebaropen === false ? 'sidebar-hide' : '')}>

                        <div className="desktop-filter">
                            <FilterDesktop
                                filter={filter}
                                categories={categories}
                                members={members}
                                onSelectCategory={onSelectCategory}
                                onSelectPlace={onSelectPlace}
                                onSelectFilter={this.onFilterChange}
                                onChangeSort={onChangeSort}
                                onSliderChange={onSliderChange}
                                onSliderChangeComplete={onSliderChangeComplete}
                                handleGeoPosition={handleGeoPosition}
                                removeGeoPosition={removeGeoPosition}
                                schema={this.state.schema}
                                onSchemaChange={(schema) => {
                                    this.setState({
                                        schema: schema,
                                        selectedMarker: {
                                            key: null,
                                            member: {}
                                        }
                                    }, () => {
                                        try {
                                            window.scrollTo(0,0);
                                        } catch (error) {

                                        }
                                    })
                                }}
                            />
                            {
                                (this.state.schema === SCHEMA_MAP)
                                    ?
                                    <div className="bg-box-grey">
                                        <MemberList
                                            members={members}
                                            categories={categories}
                                            onClick={(member, index) => {
                                                changeUrlForMember(member);
                                                this.setState({
                                                    selectedMarker: {
                                                        key: index,
                                                        index,
                                                        member
                                                    }
                                                })
                                            }}
                                        />
                                    </div>
                                    :
                                    <Fragment/>

                            }

                        </div>
                        <div className="desktop-map-wrapper">
                            <div className="desktop-map" style={{
                                display: (this.state.selectedMarker.key !== null) ? 'none' : 'block'
                            }}>
                                {
                                    (this.state.schema === SCHEMA_MAP)
                                        ?
                                        <MapView
                                            key="map-view-stable"
                                            categories={categories}
                                            members={members}
                                            mapProps={mapProps}
                                            filter={filter}
                                            onMarkerClick={(event, member, index) => {
                                                changeUrlForMember(member);
                                                this.setState({
                                                    selectedMarker: {
                                                        key: index,
                                                        index,
                                                        member
                                                    }
                                                })
                                            }}
                                        />
                                        :
                                        <div className="desktop-list-view" style={{
                                            display: (this.state.selectedMarker.key !== null) ? 'none' : ''
                                        }}>
                                            <div className="desktop-list-sortbar">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-12 text-right">
                                                            {members.length} Mitglieder
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <ListView
                                                categories={categories}
                                                members={members}
                                                onClick={(member, index) => {
                                                    changeUrlForMember(member);
                                                    this.setState({
                                                        selectedMarker: {
                                                            key: index,
                                                            index,
                                                            member
                                                        }
                                                    })
                                                }}
                                            />
                                        </div>
                                }


                            </div>
                            {
                                (this.state.selectedMarker.key !== null)
                                    ?
                                    <Fragment>
                                        <MemberDetail
                                            version={this.props.version}
                                            member={this.state.selectedMarker.member}
                                            categories={categories}
                                            selected={this.state.selectedMarker.key}
                                            total={members.length}
                                            handleSidebar={(open) => {
                                                this.setState({
                                                    sidebaropen: open
                                                })
                                            }}
                                            onClose={() => {
                                                changeUrl(this.props.application.url);
                                                this.setState({
                                                    selectedMarker: {
                                                        key: null,
                                                        member: {},
                                                    }
                                                })
                                            }}
                                            onPrev={() => {

                                                let newKey = this.state.selectedMarker.key - 1;
                                                if (newKey < 0) {
                                                    newKey = (members.length - 1);
                                                }

                                                changeUrlForMember(members[newKey]);

                                                this.setState({
                                                    selectedMarker: {
                                                        key: newKey,
                                                        member: members[newKey],
                                                    }
                                                })
                                            }}
                                            onNext={() => {

                                                let newKey = this.state.selectedMarker.key + 1;
                                                if (newKey > (members.length - 1)) {
                                                    newKey = 0;
                                                }

                                                changeUrlForMember(members[newKey]);

                                                this.setState({
                                                    selectedMarker: {
                                                        key: newKey,
                                                        member: members[newKey],
                                                    }
                                                })
                                            }}
                                        />
                                    </Fragment>
                                    :
                                    <Fragment/>
                            }
                        </div>

                    </div>
                </LoadScript>
            </Fragment>
        );
    }

}

export default Desktop;
